import { Link } from "react-router-dom";

export default function Logo({ light = false }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center shrink-0" aria-label="ICROPSIA India Pvt Ltd — Home">
      <span className={light ? "bg-brand-ivory rounded-xl px-3.5 py-2 shadow-lg" : ""}>
        <img src="/logo.png" alt="ICROPSIA India Pvt Ltd" className="h-9 sm:h-10 w-auto" />
      </span>
    </Link>
  );
}
